module.exports = __webpack_public_path__ + "imgs/d8c11536f16169b128dacb667658c001.jpg";